import { itwApi } from "@application/api/middlewares/api";
const getIncidentAlerts = async () => {
    var response = await itwApi.get(`incident/get-alerts`);
    return response.data;
};
const updateIncidentAlerts = async (id) => {
    const response = await itwApi.put(`/incident/${id}`);
    return response.data;
};
const IncidentAPI = {
    getIncidentAlerts,
    updateIncidentAlerts
};
export default IncidentAPI;
